/* routine-autocard.js — خفيف + Reveal-on-scroll friendly
   - يبني كروت <a.routine-product> فقط عند ظهور القسم (على الإضافة/الكشف).
   - نفس منطقك الأصلي: بديل via data-alt، الكولاج، زر أضف الكل، القصّ بالكانفاس، إلخ.
*/

document.addEventListener('DOMContentLoaded', () => {
  const ROOT = document.querySelector('.skincare-article, .article-template, .rte, .article-content') || document;
  const isEN  = location.pathname.startsWith('/en/');
  const TXT   = isEN
    ? { add:'Add to Cart', wish:'Add to Wishlist', qv:'Quick View', price:'Price', reg:'Regular price', sale:'Sale price', addAll:'Add All Products' }
    : { add:'أضف إلى السلة', wish:'أضف إلى المفضّلة', qv:'عرض سريع', price:'السعر', reg:'السعر العادي', sale:'سعر التخفيض', addAll:'أضف كل المنتجات' };

  /* ---------- helpers ---------- */
  function handleFromHref(href) {
    try { return new URL(href, location.origin).pathname.match(/\/products\/([^\/?#]+)/i)?.[1] || null; }
    catch { return (href||'').match(/\/products\/([^\/?#]+)/i)?.[1] || null; }
  }
  const money = (window.Shopify && Shopify.formatMoney)
    ? (c) => Shopify.formatMoney(c, (window.theme && theme.moneyFormat) || '${{amount}}')
    : (c) => (c/100).toFixed(2);

  function sectionIdOf(anchor) {
    return document.querySelector('input[name="section-id"]')?.value
      || anchor.closest('[data-section-id]')?.getAttribute('data-section-id')
      || document.querySelector('[data-section-id]')?.getAttribute('data-section-id')
      || anchor.closest('[id^="shopify-section-"]')?.id
      || document.querySelector('[id^="shopify-section-"]')?.id
      || 'template--article__routine';
  }

  const makeSized = (url, size) => url ? url.replace(/(\.jpg|\.jpeg|\.png|\.webp)(\?.*)?$/i, (m)=>`_${size}${m}`) : null;
  const escapeHTML = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  let brandLogoMap = null;
  function handleize(value){
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function brandInfo(vendor){
    if(!vendor) return null;
    if(brandLogoMap === null){
      brandLogoMap = {};
      try{
        const source = document.getElementById('bt-routine-brand-logos');
        if(source?.textContent) brandLogoMap = JSON.parse(source.textContent);
      }catch{}
    }
    const direct = brandLogoMap[handleize(vendor)];
    if(direct) return direct;
    const wanted = String(vendor).trim().toLowerCase();
    return Object.values(brandLogoMap).find((item)=>String(item?.name || '').trim().toLowerCase() === wanted) || null;
  }
  function srcset(raw){
    if(!raw) return '';
    const sizes=['165x','360x'];
    const wMap={'165x':'165w','360x':'360w'};
    return sizes.map(s=>makeSized(raw,s)).filter(Boolean).map((u,i)=>`${u} ${wMap[sizes[i]]}`).join(', ');
  }
  function ratioOf(anchor, product){
    const pref=(anchor.getAttribute('data-image-ratio')||'').trim();
    if(pref===''||pref==='square') return 1;
    if(pref==='portrait') return 0.8;
    if(pref==='adapt_image'){
      const r=product?.featured_image?.aspect_ratio;
      return (typeof r==='number' && r>0)? r : 1;
    }
    const n=parseFloat(pref); return (!isNaN(n) && n>0)? n : 1;
  }

  /* ---------- Drawer ---------- */
  function dialogEl(){ return document.getElementById('CartDrawer'); }

  function shopRoot(){
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function wireDrawer() {
    const dlg = dialogEl();
    if (!dlg) return;
    if (dlg._wired) dlg._wired.forEach(off => off());
    dlg._wired = [];
    const onBackdrop = (e) => { if (e.target === dlg) closeDrawer(); };
    dlg.addEventListener('click', onBackdrop);
    dlg._wired.push(() => dlg.removeEventListener('click', onBackdrop));
    const onEsc = (e) => { if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closeDrawer(); } };
    document.addEventListener('keydown', onEsc);
    dlg._wired.push(() => document.removeEventListener('keydown', onEsc));
    const btn = dlg.querySelector('[aria-controls="CartDrawer"]');
    if (btn) {
      const onBtn = (e) => { e.preventDefault(); closeDrawer(); };
      btn.addEventListener('click', onBtn);
      dlg._wired.push(() => btn.removeEventListener('click', onBtn));
    }
    const onClose = () => {
      document.documentElement.classList.remove('is--cart-open');
      document.body.classList.remove('is--cart-open');
    };
    dlg.addEventListener('close', onClose);
    dlg._wired.push(() => dlg.removeEventListener('close', onClose));
  }

  async function openDrawer(){
    if (window.customElements && customElements.whenDefined) {
      try {
        await Promise.race([
          customElements.whenDefined('hdt-cart-drawer'),
          new Promise((resolve)=>setTimeout(resolve, 700))
        ]);
      } catch {}
    }

    const root=document.querySelector('hdt-cart-drawer');
    const dlg=dialogEl();
    if(root && typeof root.open==='function'){
      root.open();
      return;
    }
    if(dlg){
      if(typeof dlg.showModal==='function' && !dlg.open) dlg.showModal(); else dlg.setAttribute('open','');
      document.documentElement.classList.add('is--cart-open'); document.body.classList.add('is--cart-open');
      wireDrawer();
    }else{
      document.querySelectorAll(
        '[data-open-cart], [data-hdt-open-cart], .hdt-open-cart, .js-cart-open, .hdt-cart-icon,'+
        'button[aria-controls*="cart"], a[href="#cart-drawer"], [data-action="open-cart"]'
      ).forEach(el=>el.dispatchEvent(new MouseEvent('click',{bubbles:true})));
    }
    try{
      if(window.HDT_EVENT?.emit){ window.HDT_EVENT.emit('requestOpenCart'); window.HDT_EVENT.emit('openCart'); window.HDT_EVENT.emit('cart:open'); }
      document.dispatchEvent(new CustomEvent('requestOpenCart'));
      window.dispatchEvent(new CustomEvent('requestOpenCart'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      window.dispatchEvent(new CustomEvent('cart:open'));
    }catch{}
  }

  function closeDrawer(){
    const dlg=dialogEl();
    try { if(dlg && typeof dlg.close==='function' && dlg.open) dlg.close(); dlg?.removeAttribute('open'); }
    finally { document.documentElement.classList.remove('is--cart-open'); document.body.classList.remove('is--cart-open'); }
  }

  async function refreshDrawerInner(){
    const current=document.querySelector('hdt-cart-drawer[section-id]');
    if(!current) return false;
    const sid=current.getAttribute('section-id');
    if(!sid) return false;

    const res=await fetch(`${shopRoot()}?section_id=${encodeURIComponent(sid)}`,{
      credentials:'same-origin',
      headers:{Accept:'text/html,*/*'},
      cache:'no-store'
    });
    if(!res.ok) throw new Error('cart drawer refresh failed');

    const tmp=document.createElement('div');
    tmp.innerHTML=await res.text();
    const fresh=tmp.querySelector('hdt-cart-drawer');
    if(!fresh) throw new Error('cart drawer markup missing');

    const count=fresh.getAttribute('data-count');
    current.replaceWith(fresh);
    if(count!=null){
      document.querySelectorAll('hdt-cart-count').forEach((node)=>{
        node.textContent=count;
      });
    }
    await new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
    return true;
  }

  function drawerSectionId(){
    return document.querySelector('hdt-cart-drawer[section-id]')?.getAttribute('section-id') || '';
  }

  function dispatchCartUpdate(cartData, variantId){
    const sid=drawerSectionId();
    if(!sid || !cartData?.sections?.[sid]) return false;
    document.dispatchEvent(new CustomEvent('cart:update',{
      bubbles:true,
      detail:{
        resource:cartData,
        sourceId:'routine-card',
        cartData,
        actionAfterATC:'open_cart_drawer',
        source:'product-form-component',
        data:{variantId:String(variantId || '')}
      }
    }));
    return true;
  }

  async function postCartItems(items){
    const sid=drawerSectionId();
    const body=items.length===1
      ? {id:items[0].id, quantity:items[0].quantity}
      : {items};
    if(sid){
      body.sections=[sid];
      body.sections_url=window.location.pathname;
    }
    const response=await fetch(`${shopRoot()}cart/add.js`,{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify(body)
    });
    if(!response.ok) throw new Error('cart add failed');
    const cartData=await response.json();
    return dispatchCartUpdate(cartData,items[0]?.id);
  }

  /* ---------- Products & EN titles ---------- */
  const pCache=new Map();
  const enTitleCache=new Map();

  async function fetchProduct(handle){
    if(!handle) return null;
    if(pCache.has(handle)) return pCache.get(handle);
    try{
      const productJsonUrl=`${isEN?'/en':''}/products/${handle}.js`;
      const r=await fetch(productJsonUrl,{credentials:'same-origin'});
      if(!r.ok) return null;
      const p=await r.json();
      p.images=(p.images||[]).map(src=>src.startsWith('http')? src : `https:${src}`);
      p.url = `${isEN?'/en':''}/products/${p.handle || handle}`;
      pCache.set(handle,p);
      return p;
    }catch{ return null; }
  }

  async function getENTitle(handle){
    if(!isEN || !handle) return null;
    if(enTitleCache.has(handle)) return enTitleCache.get(handle);
    try{
      const res=await fetch(`/en/products/${handle}`,{credentials:'same-origin'});
      if(!res.ok) return null;
      const html=await res.text();
      const doc=new DOMParser().parseFromString(html,'text/html');

      const ldScripts = Array.from(doc.querySelectorAll('script[type="application/ld+json"]'));
      for (const s of ldScripts){
        try{
          const data = JSON.parse(s.textContent||'');
          const arr = Array.isArray(data)? data : [data];
          for (const obj of arr){
            const tp = obj?.['@type'];
            const isProduct = (typeof tp==='string' && /product/i.test(tp))
              || (Array.isArray(tp) && tp.some(t => /product/i.test(String(t))));
            if (isProduct && obj?.name){ enTitleCache.set(handle, String(obj.name)); return String(obj.name); }
          }
        }catch{}
      }
      const og = doc.querySelector('meta[property="og:title"]')?.getAttribute('content');
      if (og){ enTitleCache.set(handle, og); return og; }
      let t = (doc.querySelector('title')?.textContent||'').trim();
      if(t){
        const seps=[' | ',' – ',' — ',' - ',' • '];
        for(const sep of seps){ const parts=t.split(sep); if(parts.length>1){ t=parts[0].trim(); break; } }
        enTitleCache.set(handle, t); return t;
      }
      return null;
    }catch{ return null; }
  }

  async function localizeTitleIfEN(p){
    return p;
  }

  const pickAvail = (p)=> p?.variants?.find(v=>v && v.available) || null;

  /* ---------- Render card ---------- */
  function cardHTML(p,v,qty,ratio,anchor){
    const imgMain=p.images?.[0]||null, imgHover=p.images?.[1]||null;
    const setMain=srcset(imgMain), setHover=srcset(imgHover);
    const sizes='(min-width:1150px) calc((1200px - (30 * (4 - 1))) * 1 / 4),(min-width:768px) calc((100vw - (15 * (3 - 1))) * 1 / 3), calc((100vw - (15 * (2 - 1))) * 1 / 2)';
    const sid=sectionIdOf(anchor);
    const productURL=escapeHTML(p.url);
    const productTitle=escapeHTML(p.title);
    const productHandle=escapeHTML(p.handle || p.url.split('/').pop());
    const brand=brandInfo(p.vendor);
    const vendorName=escapeHTML(p.vendor || brand?.name || '');
    const vendorMarkup=brand?.logo
      ? `<div class="hdt-card-product__vendor hdt-has-img__vendor bt-routine-brand"><span><img src="${escapeHTML(brand.logo)}" alt="${vendorName}" width="80" height="28" loading="lazy" decoding="async"></span></div>`
      : (vendorName ? `<div class="hdt-card-product__vendor bt-routine-brand bt-routine-brand--text"><span>${vendorName}</span></div>` : '');
    const onSale=v.compare_at_price && v.compare_at_price>v.price;
    const discountPercent=onSale ? Math.round(((v.compare_at_price-v.price)/v.compare_at_price)*100) : 0;
    return `
<hdt-card-product
  class="hdt-card-product bt-card-promax bt-card-product1 bt-original-product-card hdt-pr-style1"
  data-bt-routine-card
  data-product-id="${p.id}">
  <div class="hdt-card-product__wrapper">
    <div class="hdt-card-product__media hdt-relative hdt-oh">
      <a data-pr-url="" href="${productURL}" data-instant="" calc-nav=""
         class="hdt-card-product__media-wrapp hdt-ratio"
         style="--aspect-ratioapt:${ratio}; --aspect-ratio:${ratio}">
        ${imgMain?`<img src="${escapeHTML(imgMain)}" alt="${productTitle}"
             srcset="${setMain}" width="1280" height="1280" loading="lazy"
             sizes="${sizes}" class="hdt-card-product__media--main">`:''}
        ${imgHover?`<img src="${escapeHTML(imgHover)}" alt="${productTitle}"
             srcset="${setHover}" width="1500" height="1500" loading="lazy"
             sizes="${sizes}" class="hdt-card-product__media--hover">`:''}
      </a>

      ${discountPercent>0?`<div class="bt-card-promax__sale-pill" aria-label="${discountPercent}%">-${discountPercent}%</div>`:''}

      <div class="bt-card-promax__icons" role="group" aria-label="${productTitle}">
        <hdt-wishlist class="hdt-card-product__btn-wishlist bt-routine-action" role="button" data-id="${p.id}" action="add" placement="top" tabindex="0" data-txt-tt="${TXT.wish}">
          <svg width="24" height="24" aria-hidden="true" focusable="false" class="hdt-svg-pr-icon hdt-svg-wis" viewBox="0 0 24 24"><use xlink:href="#hdt-icon-pr-wis"></use></svg>
          <span class="sr-only">${TXT.wish}</span>
        </hdt-wishlist>

        <wrapp-hdt-open-modal-btn placement="top" class="bt-routine-quick-wrap" data-txt-tt="${TXT.qv}">
          <button type="button" handle="${productHandle}" aria-controls="hdt-quick-view-modal" aria-expanded="false" class="hdt-card-product__btn-quick-view bt-card-promax__quick bt-routine-action" aria-label="${TXT.qv}">
            <span class="hdt-pr-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="hdt-svg-pr-icon hdt-svg-qv" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </span>
            <span class="sr-only">${TXT.qv}</span>
          </button>
        </wrapp-hdt-open-modal-btn>
      </div>
    </div>

    <div class="hdt-card-product__info hdt-card-align-center">
      ${vendorMarkup}
      <div class="bt-card-promax__title-slot">
        <a data-pr-url="" href="${productURL}" class="hdt-card-product__title hdt-font-semibold hdt-line-clamp" data-instant="">${productTitle}</a>
      </div>
    </div>

    <div class="bt-card-promax__bottom">
      <div class="bt-card-promax__price-wrapper">
        <div class="hdt-price-wrapp hdt-font-normal">
          <div class="hdt-price__list">
          <hdt-price class="hdt-price">
              <span class="sr-only sr-only--inline">${onSale ? TXT.sale : TXT.price}</span>
            <span class="hdt-money">${money(v.price)}</span>
          </hdt-price>
            ${onSale
              ? `<hdt-compare-at-price class="hdt-compare-at-price"><span class="sr-only sr-only--inline">${TXT.reg}</span><span class="hdt-money">${money(v.compare_at_price)}</span></hdt-compare-at-price>`
              : '' }
          </div>
        </div>
      </div>

      <div class="bt-card-promax__add">
        <wrapp-hdt-pr-frm class="hdt-flex hdt-align-center hdt-justify-center">
          <form method="post" action="${shopRoot()}cart/add"
                accept-charset="UTF-8"
                class="hdt-product-form js-routine-atc-form"
                enctype="multipart/form-data" novalidate>
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${v.id}">
            <input type="hidden" name="quantity" value="${qty}">
            <input type="hidden" name="product-id" value="${p.id}">
            <input type="hidden" name="section-id" value="${escapeHTML(sid)}">
            <hdt-tooltip class="hdt-ultra_btn_parent hdt-pr_btn" placement="top" will-hidden-txt="">
              <button type="submit" name="add" class="hdt-card-product__btn-ultra" aria-label="${TXT.add}">
                <span class="hdt-pr-card-icon" aria-hidden="true">
                  <svg id="icon-h-cart" class="hdt-svg-pr-icon hdt-svg-atc" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </span>
                <span class="hdt-truncate sr-only">${TXT.add}</span>
              </button>
            </hdt-tooltip>
          </form>
        </wrapp-hdt-pr-frm>
      </div>
    </div>
  </div>
</hdt-card-product>`;
  }

  /* ---------- Canvas Auto-Trim (للكولاج فقط) ---------- */
  /* ---------- Unique items for Add-All (لا تكرار) ---------- */
  function uniqueItems(){
    const forms=ROOT.querySelectorAll('.js-routine-atc-form');
    const seen=new Set(); const out=[];
    forms.forEach(f=>{
      const id=Number(f.querySelector('input[name="id"]')?.value);
      const q =Math.max(1, parseInt(f.querySelector('input[name="quantity"]')?.value||'1',10)||1);
      if(id && !seen.has(id)){ seen.add(id); out.push({id, quantity:q}); }
    });
    return out;
  }

  /* ---------- Read config (text/limit/cols) ---------- */
  function readAddAllConfig(){
    const ph=ROOT.querySelector('#routine-add-all-here');
    const result = { text: TXT.addAll, limit: 10, cols: null, placeholder: ph };
    if(!ph) return result;
    const tAttr = (ph.getAttribute('data-add-all-text')||'').trim();
    const tNode = (ph.textContent||'').trim();
    result.text = tAttr || tNode || TXT.addAll;
    const lim = parseInt(ph.getAttribute('data-thumb-limit')||'',10);
    if(!isNaN(lim) && lim>0) result.limit = lim;
    const cols = parseInt(ph.getAttribute('data-thumb-cols')||'',10);
    if(!isNaN(cols) && cols>0) result.cols = cols;
    return result;
  }

  /* ---------- Build collage (grid only) ---------- */
  function buildCollageElement(items, limit, cols){
    const stage = document.createElement('div');
    stage.className = 'routine-cart-stage';

    const grid = document.createElement('div');
    grid.className = 'routine-collage';
    if (cols && cols>0) grid.style.setProperty('--cols', String(cols));

    const max = Math.max(1, limit || 10);
    const show = items.slice(0, max);
    const remain = Math.max(0, items.length - show.length);

    // IntersectionObserver لقصّ الصور عند ظهورها (أخف)
    show.forEach(it=>{
      const a=document.createElement('a'); a.href=it.url; a.setAttribute('aria-label', it.title||'');
      const img=document.createElement('img');
      img.loading='lazy'; img.decoding='async'; img.alt=it.title||'';
      img.width=165; img.height=165;
      img.src=it.thumb165;
      if (it.srcset) img.setAttribute('srcset', it.srcset);
      a.appendChild(img); grid.appendChild(a);
    });

    if(remain>0){
      const more=document.createElement('a');
      more.href=show[show.length-1]?.url || '#';
      more.className='more-tile';
      more.textContent = (isEN ? '+' : '+') + String(remain);
      grid.appendChild(more);
    }

    stage.appendChild(grid);
    return stage;
  }

  /* ---------- Place button + stage (idempotent) ---------- */
  function placeAddAll(text, totalCount, collageStageEl){
    // لو موجود مسبقًا، حدّث بدل الإنشاء
    const existing = ROOT.querySelector('.routine-unified');
    if (existing){
      const t = existing.querySelector('.routine-add-all-text');
      if (t) t.innerHTML = `${text} <bdi>(${totalCount})</bdi>`;
      if (collageStageEl){
        const old = existing.querySelector('.routine-cart-stage');
        if (old) old.replaceWith(collageStageEl); else existing.insertBefore(collageStageEl, existing.firstChild);
      }
      return existing;
    }

    const wrap = document.createElement('div');
    wrap.className = 'routine-unified';

    if (collageStageEl) wrap.appendChild(collageStageEl);

    const bar = document.createElement('div');
    bar.className = 'routine-add-all-bar';
    bar.innerHTML = `
      <hdt-tooltip class="hdt-ultra_btn_parent hdt-pr_btn routine-add-all-holder" placement="top" will-hidden-txt="">
        <button type="button"
                class="hdt-card-product__btn-ultra routine-add-all-btn"
                aria-label="${text}">
          <span class="hdt-pr-card-icon" aria-hidden="true">
            <svg id="icon-h-cart" class="hdt-svg-pr-icon hdt-svg-atc" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </span>
          <span class="hdt-truncate routine-add-all-text">${text} <bdi>(${totalCount})</bdi></span>
        </button>
      </hdt-tooltip>
    `;
    wrap.appendChild(bar);

    const ph = ROOT.querySelector('#routine-add-all-here');
    if (ph){ ph.insertAdjacentElement('afterend', wrap); } else { ROOT.appendChild(wrap); }
    return wrap;
  }

  async function addBulk(items){
    if(!items.length) return;
    return postCartItems(items);
  }

  /* ================== هنا التعديل الرئيسي: نبني فقط عند ظهور القسم ================== */

  // سنستخدم WeakSet لمنع بناء نفس الرابط مرّتين
  const builtAnchors = new WeakSet();

  // مصفوفة الكولاج العامة (تتراكم كلما بنينا كروت جديدة)
  const collage = [];

  // يبني مجموعة روابط داخل جذر معيّن (section/عنصر كشف)
  function buildLinksUnder(root){
    const anchorsAll = Array.from(root.querySelectorAll('a.routine-product[href*="/products/"]')).filter(a=>!builtAnchors.has(a));
    if(!anchorsAll.length) return;

    // مثل منطقك: تجميع أساسي + بديل (data-alt أو العنصر التالي بعلامة data-alt)
    const usedAsAlt = new Set();
    const groups = [];
    anchorsAll.forEach((a,i)=>{
      if(usedAsAlt.has(a)) return;
      let altHref = (a.getAttribute('data-alt')||'').trim();
      if(!altHref){
        const next=anchorsAll[i+1];
        if(next && next!==a && next.hasAttribute('data-alt')){ altHref=next.getAttribute('href')||''; usedAsAlt.add(next); }
      }
      groups.push({ primary:a, altHref });
    });

    const buildTasks = groups.map(async ({primary, altHref})=>{
      if (builtAnchors.has(primary)) return;
      builtAnchors.add(primary);

      const qty=Math.max(1, parseInt(primary.getAttribute('data-qty')||'1',10) || 1);
      const h1=handleFromHref(primary.getAttribute('href')||'');
      const h2=altHref ? handleFromHref(altHref) : null;

      let p = await fetchProduct(h1);
      let v = pickAvail(p);

      if(!v && h2){
        const ap=await fetchProduct(h2);
        const av=pickAvail(ap);
        if(ap && av){ p=ap; v=av; }
      }
      if(!p || !v){ primary.remove(); return; }

      p = await localizeTitleIfEN(p);
      const ratio=ratioOf(primary, p);

      const baseImg = p.images?.[0] || null;
      const thumb165 = baseImg ? makeSized(baseImg,'165x') : null;
      if (thumb165) {
        collage.push({ id: p.id, handle: p.handle, url: p.url, thumb165, title: p.title, srcset: srcset(baseImg) });
      }

      const host=document.createElement('div'); host.innerHTML=cardHTML(p,v,qty,ratio,primary);
      const card=host.firstElementChild;

      const next=primary.nextElementSibling;
      if(next && next.matches('a.routine-product[data-alt]')) next.remove();

      primary.replaceWith(card);
    });

    Promise.all(buildTasks).then(()=>{
      // إضافة فردية: add → refresh → open  (نربط مرة واحدة فقط على ROOT)
      if (!ROOT.__routineSubmitWired){
        ROOT.__routineSubmitWired = true;
        ROOT.addEventListener('submit', async (ev)=>{
          const form=ev.target.closest('.js-routine-atc-form'); if(!form) return;
          ev.preventDefault();
          const btn=form.querySelector('button[type="submit"]');
          const fd=new FormData(form);
          const id=Number(fd.get('id'));
          const quantity=Math.max(1, parseInt(fd.get('quantity')||'1',10)||1);
          let added=false;
          try{
            btn?.setAttribute('disabled','disabled'); btn?.setAttribute('aria-busy','true');
            const updatedNatively=await postCartItems([{id,quantity}]);
            added=true;
            if(!updatedNatively){
              try { await refreshDrawerInner(); } catch {}
              await openDrawer();
            }
          }catch{
            if(!added) form.submit();
            else await openDrawer();
          }finally{
            btn?.removeAttribute('disabled'); btn?.removeAttribute('aria-busy');
          }
        });
      }

      // زر أضف الكل + الكولاج
      const cfg = readAddAllConfig();
      const deduped = (() => {
        const by = new Set(); const out=[];
        collage.forEach(it=>{
          const key = (it.id != null ? `id:${it.id}` :
                      it.handle ? `h:${it.handle}` : `u:${it.url}`);
          if(!by.has(key)){ by.add(key); out.push(it); }
        });
        return out;
      })();

      const items = uniqueItems();
      if(items.length > 1){
        const stageEl = deduped.length ? buildCollageElement(deduped, cfg.limit, cfg.cols) : null;
        const wrap = placeAddAll(cfg.text, items.length, stageEl);
        const btn = wrap.querySelector('.routine-add-all-btn');

        if (btn && !btn.__wired){
          btn.__wired = true;
          btn.addEventListener('click', async ()=>{
            try{
              btn.disabled=true; btn.setAttribute('aria-busy','true');
              const fresh=uniqueItems(); if(!fresh.length) return;
              const updatedNatively=await addBulk(fresh);
              if(!updatedNatively){
                try { await refreshDrawerInner(); } catch {}
                await openDrawer();
              }
            }finally{
              btn.disabled=false; btn.removeAttribute('aria-busy');
            }
          });

          // re-init لو الثيم يحتاج
        }
      }

      wireDrawer();
      document.dispatchEvent(new CustomEvent('routine:cards-ready',{detail:{root:ROOT}}));
      ROOT.dispatchEvent(new CustomEvent('products:update',{bubbles:true}));
    });
  }

  /* ---- تشغيل مبدئي على المحتوى الموجود وقت التحميل ---- */
  buildLinksUnder(ROOT);

  /* ---- دعم Reveal on scroll: أي عناصر جديدة تُضاف لاحقًا ---- */
  document.addEventListener('shopify:section:load', (e)=>{
    const root = e.target || e.detail?.sectionElement || e.detail || null;
    if (root) buildLinksUnder(root);
  });

  /* Broad document observer removed: routine links are present at article load.
    for (const m of muts){
      for (const n of m.addedNodes){
        if(!(n instanceof HTMLElement)) continue;
        // لو القسم كامل انكشف/أضيف:
        if (n.matches?.('.shopify-section, section, [data-section-id], .rte, .article-content')) {
          buildLinksUnder(n);
        }
        // أو إن كانت روابط مباشرة أضيفت:
        const hasLink = n.matches?.('a.routine-product[href*="/products/"]');
        if (hasLink) buildLinksUnder(n);
        n.querySelectorAll?.('a.routine-product[href*="/products/"]').forEach(a=>{
          buildLinksUnder(a.parentElement || n);
        });
      }
    }
  });
  */

});

(function(){
  return; /* Colors are handled by routine.css; avoid another live observer. */
  const pm = document.querySelector('.skincare-article .routine--pm');
  if(!pm) return;

  function pickAccent(){
    // جرّب لون أيقونة المفضلة أولاً
    const heart = pm.querySelector('.hdt-svg-wis, .hdt-card-product__btn-wishlist svg');
    let val = null;
    if (heart){
      const cs = getComputedStyle(heart);
      val = (cs.stroke && cs.stroke !== 'none') ? cs.stroke : cs.color;
    }
    // بديل: من متغيّر سكيم الليل
    if (!val){
      const cs = getComputedStyle(pm);
      let acc = cs.getPropertyValue('--color-accent').trim();
      if (acc){ val = acc.startsWith('rgb') ? acc : `rgb(${acc})`; }
    }
    // افتراضي آمن
    if (!val) val = 'rgb(0 119 170)';
    pm.style.setProperty('--pm-accent', val);
    return val;
  }

  function colorTitles(){
    const color = pickAccent();
    // لوّن كل عناوين المنتجات داخل الروتين الليلي بقوة !important
    pm.querySelectorAll('a.hdt-card-product__title, .hdt-card-product__title a')
      .forEach(a => a.style.setProperty('color', color, 'important'));
  }

  // شغّل بعد بناء الكروت
  setTimeout(colorTitles, 0);

  // كرّر التلوين عند أي إعادة تهيئة للثيم/الكروت
  ['htd:dom:changed','product:card:mount','wishlist:mount','quickview:mount','requestReInit']
    .forEach(ev => {
      document.addEventListener(ev, e => {
        const root = (e && e.detail && e.detail.root) ? e.detail.root : null;
        if (!root || pm.contains(root)) colorTitles();
      }, { passive: true });
    });

  // راقب أي تغييرات DOM داخل القسم الليلي
})();



document.addEventListener('DOMContentLoaded', function(){
  const article = document.querySelector('.skincare-article');
  if(!article) return;
  const am = article.querySelector('.routine--am');
  const pm = article.querySelector('.routine--pm');
  if(!am || !pm) return;

  // لو مش ملفوفين بالفعل
  if(!am.parentElement.classList.contains('routine-row') ||
     am.parentElement !== pm.parentElement){
    const row = document.createElement('div');
    row.className = 'routine-row';
    // أدخل الوِرابر قبل الصباح ثم انقل القسمين داخله
    article.insertBefore(row, am);
    row.appendChild(am);
    row.appendChild(pm);
  }
});





/* heading-collage-strip-from-collage.js
   يستخدم نفس صور الكولاج (.routine-collage img) كخلفية صف واحد تغطي .hdt-heading-image.
   لا تكرار ولا حركة. يضبط عرض كل صورة بنسبة أبعادها حتى يكتمل عرض البلوك 100%.
*/
(function(){
  'use strict';

  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  function headingImageEl(){
    return $('.hdt-main-heading .hdt-heading-image')
        || $('.hdt-section-heading .hdt-heading-image')
        || $('.hdt-heading-image');
  }

  // نقرأ الصور من نفس مربع الكولاج الذي يبنيه سكربتك: .routine-collage img
  // نفضّل أخذ نسخة أكبر لو كانت Shopify thumb (165x/360x) حتى تطلع أوضح في الهيرو
  function upscaleShopifyThumb(url){
    if(!url) return url;
    // يحوّل _165x أو _360x إلى _750x (عدّل الرقم لو تحب)
    return url.replace(/_(165x|360x)(\.[a-z0-9]+)(\?.*)?$/i, '_360x$2$3');
  }

  function readCollageSources(){
    const imgs = $$('.routine-collage img');
    const out = [];
    const seen = new Set();
    imgs.forEach(img=>{
      const src = img.currentSrc || img.src;
      if(!src) return;
      // استخدم النسخة المقصوصة (dataURL) إن كانت موجودة، وإلا كبّر thumbnail
      const use = src.startsWith('data:image') ? src : upscaleShopifyThumb(src);
      if(!seen.has(use)){
        seen.add(use);
        out.push(use);
      }
    });
    return out;
  }

  function ensureStrip(container){
    let layer = container.querySelector('.routine-heading-strip');
    if(layer) return layer;
    layer = document.createElement('div');
    layer.className = 'routine-heading-strip';
    container.appendChild(layer);
    return layer;
  }

  // نحمّل الصور مؤقتًا فقط للحصول على أبعادها الطبيعية → نحسب العرض النسبي لكل صورة
  function buildStripFrom(urls){
    const container = headingImageEl();
    if(!container || !urls.length) return;

    // لا تبني مرتين
    if (container.querySelector('.routine-heading-strip')) return;

    const strip = ensureStrip(container);

    urls.slice(0, 6).forEach((url)=>{
      const cell = document.createElement('div');
      cell.className = 'routine-heading-strip__cell';
      cell.style.flex = '1 1 0';
      const image = document.createElement('img');
      image.className = 'routine-heading-strip__img';
      image.alt = '';
      image.decoding = 'async';
      image.loading = 'lazy';
      image.src = url;
      cell.appendChild(image);
      strip.appendChild(cell);
    });
    return;

    loadImagesGetRatios(urls).then(list=>{
      const ratios = list.map(x => Math.max(0.2, (x.w || 1) / (x.h || 1))); // منع صفر
      const sum = ratios.reduce((a,b)=>a+b, 0) || 1;

      list.forEach((item, idx)=>{
        const cell = document.createElement('div');
        cell.className = 'routine-heading-strip__cell';
        // كل خلية تأخذ نسبة من العرض الكلي حسب نسبة أبعادها
        const pct = (ratios[idx] / sum) * 100;
        cell.style.flex = `0 0 ${pct}%`;

        const im = document.createElement('img');
        im.className = 'routine-heading-strip__img';
        im.alt = '';
        im.decoding = 'async';
        im.loading = 'lazy';
        im.src = item.url;

        cell.appendChild(im);
        strip.appendChild(cell);
      });
      // الصف الآن يغطي 100% من العرض بدون أي استنساخ أو حركة
    });
  }

  function run(){
    const container = headingImageEl();
    if(!container) return;

    // لو الكولاج جاهز الآن
    const urls = readCollageSources();
    if (urls.length){
      buildStripFrom(urls);
      return;
    }

    // إن ما كان جاهز (يبنى لاحقًا)، نراقب DOM لين يظهر ثم نبني مرة واحدة
    document.addEventListener('routine:cards-ready', run, {once:true});
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();



    /* يجمع كل النصوص قبل رابط المنتج داخل .routine-text ككتلة واحدة */
(function(){
  const LI = '.skincare-article .routine-section ol li';
  const LINK = ':scope > a.routine-product, :scope > .hdt-card-product, :scope > .hdt-card-product__wrapper';

  function wrap(li){
    if(li.querySelector(':scope > .routine-text')) return;
    const link = li.querySelector(LINK);
    if(!link) return;

    const textWrap = document.createElement('div');
    textWrap.className = 'routine-text';

    const kids = Array.from(li.childNodes);
    for(const node of kids){
      if(node === link) break;   // ننقل كل ما قبل الرابط
      textWrap.appendChild(node);
    }
    li.insertBefore(textWrap, link);
  }

  function boot(){ document.querySelectorAll(LI).forEach(wrap); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  return;

  // لو تولّد الكرت لاحقًا، أعد اللفّ للعنصر المتأثر
})();
